import Action, { ActionIndex, ActionNumberFilesFetchError, ActionSetFilter, ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'
import IndexState from '../State/IndexState'

const actionFilesFetchError = (oldState: IndexState, action: Action): IndexState => {
    return { ...oldState, error: (action as ActionNumberFilesFetchError).message, loading: false }
}
const actionFilter = (oldState: IndexState, action: Action): IndexState => {
    return { ...oldState, filter: (action as ActionSetFilter).filter }
}
const actionFilesFetchLoading = (oldState: IndexState, _action: Action): IndexState => {
    return { ...oldState, loading: true, error: undefined }
}

const actionReset = (_oldState: IndexState, _action: Action): IndexState => {
    return {
        data: [], loading: false, error: undefined, filter: {
            address: '',
            fileTypeId: 0,
            propertyValueList: [],
            tags: []
        }
    }
}

const actionFiles = (oldState: IndexState, action: Action): IndexState => {
    let data = oldState.data
    let more = (action as ActionIndex).data
    data.push(...more)
    return { ...oldState, loading: false, error: undefined, data: data }
}



type Process = (oldState: IndexState, action: Action) => IndexState

export const IndexReducer: Reducer<IndexState, Action> = (state: IndexState = {
    data: [], loading: false, error: undefined, filter: {
        address: '',
        fileTypeId: 0,
        propertyValueList: [],
        tags: []
    }
}, action: Action): IndexState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.INDEX_LOAGING, actionFilesFetchLoading)
    actionMap.set(ActionType.INDEX_DATA, actionFiles)
    actionMap.set(ActionType.INDEX_ERROR, actionFilesFetchError)
    actionMap.set(ActionType.INDEX_SET_FILTER, actionFilter)
    actionMap.set(ActionType.INDEX_RESET, actionReset)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


